import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const AgentTypeSelector = ({ selectedAgent, onAgentChange }) => {
  const agentTypes = [
    {
      value: 'proposal-bot',
      label: 'ProposalBot',
      description: 'Automated proposal generation and client pitch creation',
      capabilities: [
        'Market analysis integration',
        'Competitive landscape mapping',
        'ROI projections and forecasting',
        'Client-specific customization'
      ],
      icon: 'FileText',
      color: 'from-blue-500 to-indigo-600'
    },
    {
      value: 'insight-miner',
      label: 'InsightMiner',
      description: 'Deep data analysis and pattern recognition across multiple sources',
      capabilities: [
        'Cross-platform data extraction',
        'Sentiment analysis and trends',
        'Demographic segmentation',
        'Predictive modeling'
      ],
      icon: 'Search',
      color: 'from-purple-500 to-violet-600'
    },
    {
      value: 'efficiency-auditor',
      label: 'Efficiency Auditor',
      description: 'Workflow optimization and performance enhancement analysis',
      capabilities: [
        'Process bottleneck identification',
        'Resource allocation optimization',
        'Cost-benefit analysis',
        'Performance benchmarking'
      ],
      icon: 'BarChart3',
      color: 'from-emerald-500 to-teal-600'
    }
  ];

  const selectOptions = agentTypes?.map(agent => ({
    value: agent?.value,
    label: agent?.label,
    description: agent?.description
  }));

  const selectedAgentData = agentTypes?.find(agent => agent?.value === selectedAgent);

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-foreground mb-2">
          Select AI Agent Type
        </h2>
        <p className="text-text-secondary">
          Choose the specialized agent that best fits your research objectives
        </p>
      </div>
      <div className="max-w-md mx-auto">
        <Select
          label="Agent Type"
          placeholder="Choose an AI agent..."
          options={selectOptions}
          value={selectedAgent}
          onChange={onAgentChange}
          searchable
          required
        />
      </div>
      {selectedAgentData && (
        <div className="bg-card border border-border rounded-xl p-6 animate-fade-in">
          <div className="flex items-start space-x-4">
            <div className={`w-12 h-12 bg-gradient-to-br ${selectedAgentData?.color} rounded-lg flex items-center justify-center flex-shrink-0`}>
              <Icon 
                name={selectedAgentData?.icon} 
                size={24} 
                color="white" 
                strokeWidth={2}
              />
            </div>
            
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-card-foreground mb-2">
                {selectedAgentData?.label}
              </h3>
              <p className="text-text-secondary mb-4">
                {selectedAgentData?.description}
              </p>
              
              <div>
                <h4 className="text-sm font-medium text-card-foreground mb-2">
                  Key Capabilities:
                </h4>
                <ul className="space-y-1">
                  {selectedAgentData?.capabilities?.map((capability, index) => (
                    <li key={index} className="flex items-center space-x-2 text-sm text-text-secondary">
                      <Icon name="Check" size={14} className="text-success flex-shrink-0" />
                      <span>{capability}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgentTypeSelector;